import { type ThemeType } from "@cruk/cruk-react-components";
import styled from "styled-components";

export const SuppressionsFieldset = styled.fieldset<{ theme: ThemeType }>`
  padding: 0;
  margin: 0 0 ${({ theme }) => theme.spacing.s} 0;
  border: none;
  fieldset {
    padding: 0;
    margin: 0 0 ${({ theme }) => theme.spacing.s} 0;
    legend {
      max-width: 32%;
    }
    > label {
      margin-left: 4%;
      width: 30%;
    }
    input {
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

export default SuppressionsFieldset;
